export default __webpack_public_path__ + "static/media/vollkorn-bold.19ae1468.ttf";